import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { generateRedirectUrl } from '@domain-group/javascript-utils'

import { generateUrls } from '@hooks/useProviderPackage'

import { ProviderPackageModel } from '@domain-group/realhub-backend-api-types'

interface ProviderPackageListItemProps {
  providerPackage: ProviderPackageModel,
}

const ProviderPackageListItem = (props: ProviderPackageListItemProps) => {
  const { providerPackage } = props

  const { title, id } = providerPackage

  const { editProviderPackageUrl } = generateUrls({ id })

  return (
    <DashboardModuleListItem title={title}>
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {`# ${id}`}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>

      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          href={`${editProviderPackageUrl}?redirect=${generateRedirectUrl()}`}
          type="link"
        />
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

export default ProviderPackageListItem
